
(function (window, angular, undefined) {
    angular.module('formApp')
        .service('dataLayerService', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
            this.partnerName = function () {
                if ($rootScope.partnerName) {
                    return $rootScope.partnerName;
                }
                else {
                    return '';
                }
            };
            this.campaignCode = function () {
                if ($rootScope.campaignCode) {
                    return $rootScope.campaignCode;
                }
                else {
                    return '';
                }
            };
            this.multiPetTest = function (int) {
                if (int >= 2) {
                    return true;
                } else {
                    return false;
                }
            };
            this.getBreed = function (pets) {
                var breed;
                var multipet = false;

                if (pets.length >= 2) {
                    multipet = true;
                    breed = [];
                }
                pets.forEach(function (value, key) {
                    if (value.type === "dog") {
                        if (value.details.type === "MultiBreed") {

                            if (multipet) {
                  
                                breed.push(value.details.breedOne,value.details.breedOne );
                            }
                            else {
                                breed = value.details.breedOne + ',' + value.details.breedTwo;
                            
                            }
                        }
                        else if (value.details.type === "SingleBreed") {

                            if (multipet) {
                  
                                breed.push(value.details.breedOne);
                            }
                            else {
                                breed = value.details.breedOne;
                            }
                        }
                    }
                    if (value.type !== "dog") {
                        if (multipet) {
                            breed.push(value.details.breed);
                        }
                        else {
                            breed = value.details.breed;
                        }
                    }
                });
                return breed;
            };

            function returnPetAge(dob){
                var a = moment();
                var b = moment(dob);

                
                var years = a.diff(b, 'year');
                b.add(years, 'years');
                
                var months = a.diff(b, 'months');
                b.add(months, 'months');
                
                var days = a.diff(b, 'days');

                var petAge =
                {
                    "years": years,
                    "months": months,
                    "days": days
                };
                
                 return petAge;
                
            }

            this.getQuoteVar = function () {

                var quoteVariables = [];
                $rootScope.gaPetData.forEach(function (value, key) {

                    var petPos = parseInt(key) + 1,
                        petWeight;

                    if (value.details.weight) {
                        petWeight = value.details.weight;
                    }
                    else {
                        petWeight = "n/a";
                    }
                    function setPet() {
              

                        if (value.details.type === 'SingleBreed') {

                            return value.details.breedOne;

                        }
                        if (value.details.type === 'MultiBreed') {

                            return value.details.breedOne + ',' + value.details.breedTwo;

                        }
                        if (value.details.breed) {

                            return value.details.breed;
                        }
                    }
                    var pet = {
                        'petId': value.id,
                        'petDetailsPosition': petPos,
                        'policyAmount': value.totalAnnual,
                        'policyType': value.chosenCover ? value.chosenCover.productId : undefined,
                        'species': value.type,
                        'petType': value.details.type,
                        'breed': setPet(),
                        //'weight': petWeight,
                        'gender': value.details.sex,
                        //    'age': '2 years 6 months',
                        'neutered': value.details.spayedOrNeutered,
                        "petAge" :returnPetAge(value.details.dateOfBirth)
                    };
      
                    quoteVariables.push(pet);
                });
                return quoteVariables;
            };
            this.setRetrieveMode = function () {
                if (sessionStorage.getItem('retrieveQuote') === 'true') {
                    return true;
                }
                else {
                    return false;
                }
            };
            this.setFunnel = function () {
                if (sessionStorage.getItem('eQuote') === 'true') {
                    return 2.0;
                }
                else {
                    return 1.0;
                }
            };
            this.setFunnelName = function () {
                if ($rootScope.eCoverNote) {
                    return '7';
                }
                else if (sessionStorage.getItem('eQuote') === 'true') {
                    return '2';
                }
                else {
                    return $rootScope.campaignFunnel;
                }
            };
            this.ifDeathIllness = function () {
                var totalUpgradeValue = [];
                angular.forEach($rootScope.gaPetData, function (value, key) {
                    if (value.upgradeAnnualPremium != null) {
                        totalUpgradeValue.push(value.upgradeAnnualPremium);
                    }

                });
            };
            this.paymentType = function (pt) {
                if (pt.annualPaymentMethod === 'DD') {
                    return 'Annual DD';
                }
                if (pt.annualPaymentMethod === 'CC') {
                    return 'Annual CC';
                }
                if (pt.dd.monthlyOrYearly === 'MD') {
                    return 'Monthly DD';
                }
            };
            this.paymentFreq = function (pf) {
                if (pf.annualPaymentMethod === 'DD') {
                    return 'Annual';
                }
                if (pf.annualPaymentMethod === 'CC') {
                    return 'Annual';
                }
                if (pf.dd.monthlyOrYearly === 'MD') {
                    return 'Monthly';
                }
            };
        }]);
})(window, window.angular);